import {
  Divider,
  Paper,
  Theme,
  ThemeProvider,
  Typography,
} from "@material-ui/core";
import { formatDistance, parseISO } from "date-fns";
import { Translate } from "react-admin";
import TrailerOutlineIcon from "../../common/icons/TrailerOutlineIcon";

interface Props {
  theme: Theme;
  translate: Translate;
  name: string;
  geolocation?: string | null;
  inMotion?: boolean | null;
  odometer?: number | null;
  lastMotionStatusChange?: string | null;
  isMobile?: boolean | null;
}

export const DashboardTrailerInfoWindowContent = ({
  name,
  inMotion,
  odometer,
  geolocation,
  lastMotionStatusChange,
  theme,
  translate,
  isMobile = false,
}: Props) => {
  return (
    <div
      className={`info-window-content ${
        isMobile ? "info-window-content__mobile" : null
      }`}>
      <ThemeProvider theme={theme}>
        <Paper style={{ backgroundColor: theme.palette.background.paper }}>
          <div className="info-window-content-header">
            <div className="header-info" style={{ width: "100%" }}>
              <div>
                <Typography variant="body2">
                  {translate("resources.locations-current.labels.motionStatus")}
                </Typography>
              </div>
              <div>
                {inMotion ? (
                  <Typography variant="body2">
                    <TrailerOutlineIcon
                      fontSize="small"
                      style={{ color: theme.palette.success.main }}
                    />
                  </Typography>
                ) : (
                  <Typography variant="body2">
                    <TrailerOutlineIcon
                      fontSize="small"
                      style={{ color: theme.palette.error.main }}
                    />
                  </Typography>
                )}
              </div>
            </div>
          </div>
          <Divider />
          <div className="info-window-content-paper">
            <div className="info-window-content-group">
              <div>
                <Typography variant="body2">
                  {translate("resources.locations-current.labels.trailerName")}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">{name}</Typography>
              </div>
            </div>
            <div className="info-window-content-group">
              <div>
                <Typography variant="body2">
                  {translate("resources.locations-current.labels.geolocation")}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">{geolocation ?? "-"}</Typography>
              </div>
            </div>
            <div className="info-window-content-group">
              <div>
                <Typography variant="body2">
                  {translate("resources.locations-current.labels.odometer")}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">
                  {odometer ? (odometer !== 0 ? odometer : "-") : "-"}
                </Typography>
              </div>
            </div>
            <div className="info-window-content-group">
              <div>
                <Typography variant="body2">
                  {translate(
                    "resources.locations-current.labels.motionStatusDuration"
                  )}
                </Typography>
              </div>
              <div>
                <Typography variant="body2">
                  {lastMotionStatusChange
                    ? formatDistance(
                        parseISO(lastMotionStatusChange),
                        new Date()
                      )
                    : "-"}
                </Typography>
              </div>
            </div>
          </div>
        </Paper>
      </ThemeProvider>
    </div>
  );
};
